import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/render',
    component: ComponentCreator('/render', 'fdc'),
    exact: true
  },
  {
    path: '/search',
    component: ComponentCreator('/search', '0e3'),
    exact: true
  },
  {
    path: '/',
    component: ComponentCreator('/', 'b8d'),
    routes: [
      {
        path: '/',
        component: ComponentCreator('/', 'cb1'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/api/enums/InternalModifier',
        component: ComponentCreator('/api/enums/InternalModifier', 'dc0'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/addToRange',
        component: ComponentCreator('/api/functions/addToRange', '242'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/Button-1',
        component: ComponentCreator('/api/functions/Button-1', 'e27'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/Caption',
        component: ComponentCreator('/api/functions/Caption', '5d4'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/CaptionDropdowns',
        component: ComponentCreator('/api/functions/CaptionDropdowns', '0b7'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/CaptionLabel',
        component: ComponentCreator('/api/functions/CaptionLabel', '33d'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/CaptionNavigation',
        component: ComponentCreator('/api/functions/CaptionNavigation', '75d'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/Day',
        component: ComponentCreator('/api/functions/Day', '420'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/DayContent',
        component: ComponentCreator('/api/functions/DayContent', '533'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/DayPicker',
        component: ComponentCreator('/api/functions/DayPicker', 'd76'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/DayPickerProvider',
        component: ComponentCreator('/api/functions/DayPickerProvider', 'ef4'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/Dropdown',
        component: ComponentCreator('/api/functions/Dropdown', 'edf'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/FocusProvider',
        component: ComponentCreator('/api/functions/FocusProvider', '91a'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/Footer',
        component: ComponentCreator('/api/functions/Footer', '81f'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/Head',
        component: ComponentCreator('/api/functions/Head', 'a81'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/HeadRow',
        component: ComponentCreator('/api/functions/HeadRow', '1f8'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/IconDropdown',
        component: ComponentCreator('/api/functions/IconDropdown', 'f11'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/IconLeft',
        component: ComponentCreator('/api/functions/IconLeft', 'b1d'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/IconRight',
        component: ComponentCreator('/api/functions/IconRight', 'fa8'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isDateAfterType',
        component: ComponentCreator('/api/functions/isDateAfterType', 'b48'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isDateBeforeType',
        component: ComponentCreator('/api/functions/isDateBeforeType', '09b'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isDateInterval',
        component: ComponentCreator('/api/functions/isDateInterval', '368'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isDateRange',
        component: ComponentCreator('/api/functions/isDateRange', 'b5e'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isDayOfWeekType',
        component: ComponentCreator('/api/functions/isDayOfWeekType', '25f'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isDayPickerDefault',
        component: ComponentCreator('/api/functions/isDayPickerDefault', '843'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isDayPickerMultiple',
        component: ComponentCreator('/api/functions/isDayPickerMultiple', '6a7'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isDayPickerRange',
        component: ComponentCreator('/api/functions/isDayPickerRange', 'dea'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isDayPickerSingle',
        component: ComponentCreator('/api/functions/isDayPickerSingle', 'a67'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/isMatch',
        component: ComponentCreator('/api/functions/isMatch', 'd2a'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/Months',
        component: ComponentCreator('/api/functions/Months', '82a'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/NavigationProvider',
        component: ComponentCreator('/api/functions/NavigationProvider', '7c7'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/RootProvider',
        component: ComponentCreator('/api/functions/RootProvider', '3b6'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/Row',
        component: ComponentCreator('/api/functions/Row', '1ba'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/SelectMultipleProvider',
        component: ComponentCreator('/api/functions/SelectMultipleProvider', 'e81'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/SelectMultipleProviderInternal',
        component: ComponentCreator('/api/functions/SelectMultipleProviderInternal', '425'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/SelectRangeProvider',
        component: ComponentCreator('/api/functions/SelectRangeProvider', '0c0'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/SelectRangeProviderInternal',
        component: ComponentCreator('/api/functions/SelectRangeProviderInternal', '470'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/SelectSingleProvider',
        component: ComponentCreator('/api/functions/SelectSingleProvider', 'e55'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/SelectSingleProviderInternal-1',
        component: ComponentCreator('/api/functions/SelectSingleProviderInternal-1', '5a9'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/useActiveModifiers',
        component: ComponentCreator('/api/functions/useActiveModifiers', 'eea'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/useDayPicker',
        component: ComponentCreator('/api/functions/useDayPicker', '9d1'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/useDayRender',
        component: ComponentCreator('/api/functions/useDayRender', '9c4'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/useFocusContext',
        component: ComponentCreator('/api/functions/useFocusContext', '62f'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/useInput',
        component: ComponentCreator('/api/functions/useInput', 'fb5'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/useNavigation',
        component: ComponentCreator('/api/functions/useNavigation', 'd68'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/useSelectMultiple',
        component: ComponentCreator('/api/functions/useSelectMultiple', 'c84'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/useSelectRange',
        component: ComponentCreator('/api/functions/useSelectRange', 'd1d'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/useSelectSingle',
        component: ComponentCreator('/api/functions/useSelectSingle', 'b2a'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/functions/WeekNumber',
        component: ComponentCreator('/api/functions/WeekNumber', '52b'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/CaptionLabelProps',
        component: ComponentCreator('/api/interfaces/CaptionLabelProps', '03f'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/CaptionProps',
        component: ComponentCreator('/api/interfaces/CaptionProps', 'a45'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/CustomComponents',
        component: ComponentCreator('/api/interfaces/CustomComponents', '1d7'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DayContentProps',
        component: ComponentCreator('/api/interfaces/DayContentProps', '6c2'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DayPickerBase',
        component: ComponentCreator('/api/interfaces/DayPickerBase', '4ff'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DayPickerContextValue',
        component: ComponentCreator('/api/interfaces/DayPickerContextValue', 'e15'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DayPickerDefaultProps',
        component: ComponentCreator('/api/interfaces/DayPickerDefaultProps', 'b33'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DayPickerMultipleProps',
        component: ComponentCreator('/api/interfaces/DayPickerMultipleProps', 'e9b'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DayPickerProviderProps',
        component: ComponentCreator('/api/interfaces/DayPickerProviderProps', '966'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DayPickerRangeProps',
        component: ComponentCreator('/api/interfaces/DayPickerRangeProps', '833'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DayPickerSingleProps',
        component: ComponentCreator('/api/interfaces/DayPickerSingleProps', '587'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DayProps',
        component: ComponentCreator('/api/interfaces/DayProps', '5d5'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/DropdownProps',
        component: ComponentCreator('/api/interfaces/DropdownProps', 'e5e'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/FooterProps',
        component: ComponentCreator('/api/interfaces/FooterProps', '9b7'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/NavigationContextValue',
        component: ComponentCreator('/api/interfaces/NavigationContextValue', '80f'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/RowProps',
        component: ComponentCreator('/api/interfaces/RowProps', '5bf'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/SelectMultipleContextValue',
        component: ComponentCreator('/api/interfaces/SelectMultipleContextValue', 'd0c'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/SelectMultipleProviderInternalProps',
        component: ComponentCreator('/api/interfaces/SelectMultipleProviderInternalProps', '4af'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/SelectRangeContextValue',
        component: ComponentCreator('/api/interfaces/SelectRangeContextValue', '2ed'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/SelectRangeProviderInternalProps',
        component: ComponentCreator('/api/interfaces/SelectRangeProviderInternalProps', '9bb'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/SelectRangeProviderProps',
        component: ComponentCreator('/api/interfaces/SelectRangeProviderProps', 'aad'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/SelectSingleContextValue',
        component: ComponentCreator('/api/interfaces/SelectSingleContextValue', '40c'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/SelectSingleProviderInternal',
        component: ComponentCreator('/api/interfaces/SelectSingleProviderInternal', '1f8'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/SelectSingleProviderProps',
        component: ComponentCreator('/api/interfaces/SelectSingleProviderProps', 'ee9'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/UseInputOptions',
        component: ComponentCreator('/api/interfaces/UseInputOptions', '5bd'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/UseInputValue',
        component: ComponentCreator('/api/interfaces/UseInputValue', 'd0f'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/interfaces/WeekNumberProps',
        component: ComponentCreator('/api/interfaces/WeekNumberProps', 'a49'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/modules',
        component: ComponentCreator('/api/modules', 'b7e'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/namespaces/Button',
        component: ComponentCreator('/api/namespaces/Button', '539'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/ActiveModifiers',
        component: ComponentCreator('/api/types/ActiveModifiers', '0ae'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/ButtonProps',
        component: ComponentCreator('/api/types/ButtonProps', '59c'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/CaptionLayout',
        component: ComponentCreator('/api/types/CaptionLayout', 'cbe'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/ClassNames',
        component: ComponentCreator('/api/types/ClassNames', '03b'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/CustomModifiers',
        component: ComponentCreator('/api/types/CustomModifiers', 'd4e'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DateAfter',
        component: ComponentCreator('/api/types/DateAfter', '0eb'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DateBefore',
        component: ComponentCreator('/api/types/DateBefore', 'aba'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DateFormatter',
        component: ComponentCreator('/api/types/DateFormatter', 'd70'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DateInterval',
        component: ComponentCreator('/api/types/DateInterval', 'ee4'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DateRange',
        component: ComponentCreator('/api/types/DateRange', '9d2'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayClickEventHandler',
        component: ComponentCreator('/api/types/DayClickEventHandler', 'd03'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayFocusEventHandler',
        component: ComponentCreator('/api/types/DayFocusEventHandler', '2f8'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayKeyboardEventHandler',
        component: ComponentCreator('/api/types/DayKeyboardEventHandler', '6e5'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayLabel',
        component: ComponentCreator('/api/types/DayLabel', '50a'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayModifiers',
        component: ComponentCreator('/api/types/DayModifiers', '034'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayMouseEventHandler',
        component: ComponentCreator('/api/types/DayMouseEventHandler', '647'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayOfWeek',
        component: ComponentCreator('/api/types/DayOfWeek', '649'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayPickerProps',
        component: ComponentCreator('/api/types/DayPickerProps', 'afe'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayPointerEventHandler',
        component: ComponentCreator('/api/types/DayPointerEventHandler', 'd36'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayRender',
        component: ComponentCreator('/api/types/DayRender', 'a3d'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DaySelectionMode',
        component: ComponentCreator('/api/types/DaySelectionMode', 'fe5'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/DayTouchEventHandler',
        component: ComponentCreator('/api/types/DayTouchEventHandler', 'fb5'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/FocusContextValue',
        component: ComponentCreator('/api/types/FocusContextValue', 'b4a'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/FocusProviderProps',
        component: ComponentCreator('/api/types/FocusProviderProps', '341'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/Formatters',
        component: ComponentCreator('/api/types/Formatters', '696'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/InputDayPickerProps',
        component: ComponentCreator('/api/types/InputDayPickerProps', 'bc3'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/InputProps',
        component: ComponentCreator('/api/types/InputProps', 'f9c'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/InternalModifiers',
        component: ComponentCreator('/api/types/InternalModifiers', 'd0e'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/InternalModifiersElement',
        component: ComponentCreator('/api/types/InternalModifiersElement', 'e2a'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/Labels',
        component: ComponentCreator('/api/types/Labels', '3aa'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/Matcher',
        component: ComponentCreator('/api/types/Matcher', '6aa'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/Modifier',
        component: ComponentCreator('/api/types/Modifier', '6b5'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/Modifiers',
        component: ComponentCreator('/api/types/Modifiers', 'fa9'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/ModifiersClassNames',
        component: ComponentCreator('/api/types/ModifiersClassNames', '79e'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/ModifiersStyles',
        component: ComponentCreator('/api/types/ModifiersStyles', '842'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/MonthChangeEventHandler',
        component: ComponentCreator('/api/types/MonthChangeEventHandler', '1ba'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/MonthsProps',
        component: ComponentCreator('/api/types/MonthsProps', 'f8a'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/NavButtonLabel',
        component: ComponentCreator('/api/types/NavButtonLabel', 'afd'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/RootContext',
        component: ComponentCreator('/api/types/RootContext', '09d'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/SelectMultipleEventHandler',
        component: ComponentCreator('/api/types/SelectMultipleEventHandler', '306'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/SelectMultipleModifiers',
        component: ComponentCreator('/api/types/SelectMultipleModifiers', 'a20'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/SelectMultipleProviderProps',
        component: ComponentCreator('/api/types/SelectMultipleProviderProps', '921'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/SelectRangeEventHandler',
        component: ComponentCreator('/api/types/SelectRangeEventHandler', '58d'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/SelectRangeModifiers',
        component: ComponentCreator('/api/types/SelectRangeModifiers', '9a6'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/SelectSingleEventHandler',
        component: ComponentCreator('/api/types/SelectSingleEventHandler', 'f48'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/StyledComponent',
        component: ComponentCreator('/api/types/StyledComponent', 'd12'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/StyledElement',
        component: ComponentCreator('/api/types/StyledElement', 'ad6'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/Styles',
        component: ComponentCreator('/api/types/Styles', '453'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/WeekdayLabel',
        component: ComponentCreator('/api/types/WeekdayLabel', 'e0f'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/WeekNumberClickEventHandler',
        component: ComponentCreator('/api/types/WeekNumberClickEventHandler', 'd46'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/WeekNumberFormatter',
        component: ComponentCreator('/api/types/WeekNumberFormatter', '560'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/types/WeekNumberLabel',
        component: ComponentCreator('/api/types/WeekNumberLabel', '6a9'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/Button.__typeof',
        component: ComponentCreator('/api/variables/Button.__typeof', 'be2'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/Button.defaultProps',
        component: ComponentCreator('/api/variables/Button.defaultProps', 'c4a'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/Button.displayName',
        component: ComponentCreator('/api/variables/Button.displayName', 'a00'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/Button.propTypes',
        component: ComponentCreator('/api/variables/Button.propTypes', 'c34'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/DayPickerContext',
        component: ComponentCreator('/api/variables/DayPickerContext', 'f82'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/FocusContext',
        component: ComponentCreator('/api/variables/FocusContext', '3a8'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/NavigationContext',
        component: ComponentCreator('/api/variables/NavigationContext', 'ae9'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/SelectMultipleContext',
        component: ComponentCreator('/api/variables/SelectMultipleContext', 'c68'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/SelectRangeContext',
        component: ComponentCreator('/api/variables/SelectRangeContext', '908'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/api/variables/SelectSingleContext',
        component: ComponentCreator('/api/variables/SelectSingleContext', 'f7d'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/basics/customization',
        component: ComponentCreator('/basics/customization', '9b1'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/basics/keyboard',
        component: ComponentCreator('/basics/keyboard', '41b'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/basics/localization',
        component: ComponentCreator('/basics/localization', 'b17'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/basics/modifiers',
        component: ComponentCreator('/basics/modifiers', '903'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/basics/navigation',
        component: ComponentCreator('/basics/navigation', 'cc7'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/basics/selecting-days',
        component: ComponentCreator('/basics/selecting-days', '30d'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/basics/styling',
        component: ComponentCreator('/basics/styling', 'f81'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/changelog',
        component: ComponentCreator('/changelog', 'c30'),
        exact: true,
        sidebar: "developmentSidebar"
      },
      {
        path: '/contributing',
        component: ComponentCreator('/contributing', 'a8d'),
        exact: true
      },
      {
        path: '/development',
        component: ComponentCreator('/development', '404'),
        exact: true,
        sidebar: "developmentSidebar"
      },
      {
        path: '/development/conduct',
        component: ComponentCreator('/development/conduct', 'b41'),
        exact: true,
        sidebar: "developmentSidebar"
      },
      {
        path: '/development/docs',
        component: ComponentCreator('/development/docs', '3e7'),
        exact: true,
        sidebar: "developmentSidebar"
      },
      {
        path: '/development/source',
        component: ComponentCreator('/development/source', '06d'),
        exact: true,
        sidebar: "developmentSidebar"
      },
      {
        path: '/guides/custom-components',
        component: ComponentCreator('/guides/custom-components', 'c8a'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/guides/formatters',
        component: ComponentCreator('/guides/formatters', 'a7c'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/guides/input-fields',
        component: ComponentCreator('/guides/input-fields', 'adc'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/guides/upgrading',
        component: ComponentCreator('/guides/upgrading', 'dab'),
        exact: true,
        sidebar: "docsSidebar"
      },
      {
        path: '/license',
        component: ComponentCreator('/license', '1d8'),
        exact: true,
        sidebar: "developmentSidebar"
      },
      {
        path: '/reference',
        component: ComponentCreator('/reference', '2fe'),
        exact: true,
        sidebar: "apiSidebar"
      },
      {
        path: '/start',
        component: ComponentCreator('/start', '925'),
        exact: true,
        sidebar: "docsSidebar"
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
